function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 0.5,
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 40.9824,
  y: 8.74805,
  width: 2,
  height: 47,
  rx: 0.5,
  transform: "rotate(45 40.9824 8.74805)",
  fill: "currentColor"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.61328,
  y: 4,
  width: 7.22581,
  height: 7.22581,
  rx: 3.6129,
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 16C5 14.8954 5.89543 14 7 14H17C18.1046 14 19 14.8954 19 16V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V16Z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9393 13.6464L21.6464 14.3536L20.9393 13.6464L16.7071 17.8787L15.4749 16.6464C14.8891 16.0607 13.9393 16.0607 13.3536 16.6464L14.0607 17.3536L13.3536 16.6464L12.6464 17.3536C12.0607 17.9393 12.0607 18.8891 12.6464 19.4749L15.2929 22.1213C16.0739 22.9024 17.3403 22.9024 18.1213 22.1213L23.7678 16.4749C24.3536 15.8891 24.3536 14.9393 23.7678 14.3536L23.0607 15.0607L23.7678 14.3536L23.0607 13.6464C22.4749 13.0607 21.5251 13.0607 20.9393 13.6464Z",
  fill: "currentColor",
  stroke: "#1B232E",
  strokeWidth: 2
});

function SvgPersonApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonApproved);
export default __webpack_public_path__ + "static/media/person-approved.a21bb1b5.svg";
export { ForwardRef as ReactComponent };